import { CheckIcon } from "@heroicons/react/16/solid";
import { useCallback } from "react";
import { Button } from "../../../../externalComponents/tailwind/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../../externalComponents/tailwind/dialog";
import { Text } from "../../../../externalComponents/tailwind/text";
import { formatDateTime } from "../../../../functions/date-utils";

const SentDialog = ({ modalRef, name, form, navigate }) => {
  const { isSendingNow, scheduleDateTime, pacing } = form;

  const handleCancel = useCallback(() => {
    navigate("/campaigns");
  }, []);

  return (
    <Dialog open={modalRef.sent} onClose={handleCancel}>
      <DialogTitle>{name}</DialogTitle>
      <DialogBody>
        <div className="rounded-full w-[8em] h-[8em] bg-yellow m-auto pt-2 mb-6">
          <CheckIcon className="h-[7em] m-auto" />
        </div>
        <Text className="text-xl font-bold text-center">
          {`Your campaign has been ${
            isSendingNow ? "sent" : "scheduled"
          } successfully!`}
        </Text>
        <Text className="text-sm font-light text-center">
          {`On ${formatDateTime(
            isSendingNow ? new Date() : scheduleDateTime,
            "medium",
          )} to ${pacing?.effectiveSelectedContacts?.length || 0} contact${
            (pacing?.effectiveSelectedContacts?.length || 0) > 1 ? "s" : ""
          }`}
        </Text>
      </DialogBody>
      <DialogActions>
        <Button color="primaryButton" onClick={() => navigate("/campaigns")}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SentDialog;
